import { useMemo } from "react";
import { useGetPositionQuery, useGetPositionsQuery } from "./positionEndpoints";
import { Position } from "../../entities/position";

export function usePosition(positionID: number | undefined) {
  const positionQuery = useGetPositionQuery(positionID ?? 0, {
    skip: (positionID ?? 0) <= 0,
  });
  const positionEntity = positionQuery.data;

  return useMemo(() => {
    const ret: typeof positionQuery & { position?: Position | undefined } = {
      ...positionQuery,
    };
    if (positionEntity) ret.position = new Position(positionEntity);
    return ret;
  }, [positionEntity]);
}

export function usePositions() {
  const positionQuery = useGetPositionsQuery();
  const positionEntitiesMap = positionQuery.data?.entities;

  return useMemo(() => {
    const ret: typeof positionQuery & {
      positions?: Position[];
      positionsMap?: { [id: number]: Position };
    } = {
      ...positionQuery,
      positions: [],
      positionsMap: {},
    };
    if (positionEntitiesMap) {
      const positions: Position[] = [];
      const positionsMap: { [id: number]: Position } = {};

      for (const key in positionEntitiesMap) {
        if (Object.prototype.hasOwnProperty.call(positionEntitiesMap, key)) {
          const c = positionEntitiesMap[key];
          const position = new Position(c);
          positions.push(position);
          positionsMap[position.id] = position;
        }
      }
      ret.positions = positions;
      ret.positionsMap = positionsMap;
    }

    return ret;
  }, [positionEntitiesMap]);
}
